import BaseRequest from './BaseRequest';

const schema = 'commission';

export default class CommissionRequest extends BaseRequest {
  fetchCommission() {
    const url = `${schema}/commission-user`;
    return this.get(url);
  }

  fetchCommissionByTime(params) {
    const url = `${schema}/commission-user-map-time?startTime=${params[0]}&endTime=${params[1]}`;
    return this.get(url);
  }

  fetchCount() {
    const url = `${schema}/count`;
    return this.get(url);
  }

  fetchCountByTime(params) {
    const url = `${schema}/count-map-time`;
    return this.get(url);
  }
}
